export default __webpack_public_path__ + "images/RB.4e7a832.png";